/** Shared Tailwind classes for auth screens */
export const AUTH_ACCENT_LINK =
	"font-semibold text-accent transition-colors hover:text-accent-hover hover:underline";

/** 10px — auth inputs, primary buttons, outline buttons */
export const AUTH_CONTROL_RADIUS_CLASS = "!rounded-[10px]";

/** Auth CTA height — 40px (fixed px; not rem, so root font-size does not shrink buttons) */
export const AUTH_BUTTON_HEIGHT_CLASS = "h-[40px] min-h-[40px] max-h-[40px]";

/** Primary auth CTA — colors / shadow; use Button `size="auth"` for dimensions */
export const AUTH_PRIMARY_BTN_CLASS =
	"block w-full !text-base !leading-6 !font-semibold !font-['Poppins'] text-center !text-white !rounded-[10px] shadow-[0_5px_10px_rgba(0,0,0,0.05)] !bg-accent hover:!bg-accent-hover !border-0";

/** @deprecated use AUTH_PRIMARY_BTN_CLASS */
export const AUTH_SUBMIT_BUTTON_CLASS = AUTH_PRIMARY_BTN_CLASS;

export const AUTH_PRIMARY_BUTTON = AUTH_PRIMARY_BTN_CLASS;

/** Page titles (dark #161616) */
export const AUTH_HEADING_CLASS = "text-primary";

export const AUTH_OUTLINE_BUTTON_CLASS =
	"border border-accent !bg-white !text-base !leading-6 !font-semibold !text-accent hover:!bg-accent-40";

export const AUTH_OUTLINE_BUTTON_SHELL_CLASS = `block w-full ${AUTH_CONTROL_RADIUS_CLASS} ${AUTH_OUTLINE_BUTTON_CLASS}`;
